import { createStore } from 'vuex';
import VuexPersist from 'vuex-persist';
import account from './modules/account';
import adventures from './modules/adventures';
import applications from './modules/applications';
import backupCare from './modules/backupCare';
import interviewRequest from './modules/interviewRequest';
import job from './modules/job';
import messages from './modules/messages';
import navigation from './modules/navigation/index';
import sitterOnboarding from './modules/sitterOnboarding';
import { clearCache } from './cache';
import { persistedStateReducer } from './persistedStateReducer';

clearCache();

const vuexSessionStorage = new VuexPersist({
  key: 'vuex',
  storage: window.sessionStorage,
  reducer: persistedStateReducer,
});

const store = createStore({
  plugins: [vuexSessionStorage.plugin],
  modules: {
    account,
    adventures,
    applications,
    backupCare,
    interviewRequest,
    job,
    messages,
    navigation,
    sitterOnboarding,
  },
});

export default store;
